/**
 * Apps Flayer const symbols.
 * @constant
 * @type {Object}
 */
const AF = {
    ID: 'appsflyerid',
    APP_NAME: 'appname',
    DEVICE_ID: 'deviceid',
    AF_INSTALL: 'afinstall',
    SERIAL_DATA: 'serialdata',
    AFInstall: 'AFInstall',
    AppsFlyerID:'AppsFlyerID',
    APP_IDFV:'idfv'
};

export {AF};